import EditorImg from 'lowcode/components/EditorImg';
import { FC } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { Button } from '@/components/UI';
import gtm from '@/utils/gtm';
import { useReferralStore } from '../../ReferralProvider';

interface IPorps {
    isLogin: boolean;
    handleShare: () => void;
    shareKey: string;
}

const UserStories: FC<IPorps> = ({ isLogin, handleShare, shareKey = '' }) => {
    const { t } = useLang('referral');
    const { inBlackList, pageUsing } = useReferralStore();

    const list = [
        {
            img:
                pageUsing === 'd3ms'
                    ? 'https://websiteoss.ecoflow.com/figma-uploads/1760614882640-jln6gb-compressed-user_01.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1748352209505/user_01.jpg',
            desc: t('stories.stories_context1'),
            name: t('stories.stories_user1'),
        },
        {
            img:
                pageUsing === 'd3ms'
                    ? 'https://websiteoss.ecoflow.com/figma-uploads/1760614871247-3oyp4f-compressed-user_02.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1748352212273/user_02.jpg',
            desc: t('stories.stories_context2'),
            name: t('stories.stories_user2'),
        },
        {
            img:
                pageUsing === 'd3ms'
                    ? 'https://websiteoss.ecoflow.com/figma-uploads/1760614775962-btev81-compressed-user_03.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1748352214964/user_03.jpg',
            desc: t('stories.stories_context3'),
            name: t('stories.stories_user3'),
        },
    ];

    return (
        <div className={`${styled.UserStories}`}>
            <h3 className="title">{t('stories.title')}</h3>
            <p className="desc">{t('stories.desc')}</p>
            <ul className="stories-box">
                {list.map((item, index) => (
                    <li key={index} className="stories-item">
                        <div>
                            <p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                                    <g clipPath="url(#clip0_36_9130)">
                                        <path
                                            d="M0 9.93542C0 5.55889 1.845 1.72942 7.02 1V3.68974C4.275 4.64711 3.825 5.78683 3.69 8.61334H7.02V15.087H0V9.93542ZM10.98 9.93542C10.98 5.55889 12.825 1.72942 18 1V3.68974C15.255 4.64711 14.805 5.78683 14.67 8.61334H18V15.087H10.98V9.93542Z"
                                            fill="black"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_36_9130">
                                            <rect width="18" height="15" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </p>
                            <p className="stories-context">{item.desc}</p>
                        </div>
                        <div>
                            <p className="stories-user">
                                <EditorImg className="user" pc="https://websiteoss.ecoflow.com/upload/image/1732533742496/user.jpg" />
                                {item.name}
                            </p>
                            <EditorImg className="stories-img" pc={item.img} />
                        </div>
                    </li>
                ))}
            </ul>
            <div style={{ textAlign: 'center' }}>
                <Button
                    className={`us-refer-btn ${isLogin ? 'login' : ''}`}
                    onClick={() => {
                        handleShare && handleShare();
                        try {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'referral_button',
                                position: shareKey,
                                button_name: isLogin ? t('stories.btn2') : t('stories.btn1'),
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }}
                    disabled={inBlackList}
                >
                    {isLogin ? t('stories.btn2') : t('stories.btn1')}
                </Button>
            </div>
        </div>
    );
};

export default UserStories;
